import { render, staticRenderFns } from "./BureauDetailsProvider.vue?vue&type=template&id=4f0535bd&"
import script from "./BureauDetailsProvider.vue?vue&type=script&lang=js&"
export * from "./BureauDetailsProvider.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports